"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumeric = exports.isEmptyObject = exports.isEmpty = exports.isBlank = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var isEmpty = exports.isEmpty = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};
var isBlank = exports.isBlank = function isBlank(value) {
  if (isEmpty(value)) {
    return true;
  }
  return typeof value === 'string' || value instanceof String ? value.trim().length === 0 : false;
};

// eslint-disable-next-line no-restricted-globals
var isNumeric = exports.isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};
var isEmptyObject = exports.isEmptyObject = function isEmptyObject(obj) {
  return _typeof(obj) !== 'object' || obj === null || Object.keys(obj).length === 0;
};